import { OPEN_MODAL_PRODUCT } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[OPEN_MODAL_PRODUCT](value);
